import React from "react";
import { benefitsData } from "../data/mock";
import { TrendingUp, CheckCircle, Clock, DollarSign } from "lucide-react";

const iconMap = {
  blue: { icon: Clock, color: "blue" },
  green: { icon: CheckCircle, color: "green" },
  purple: { icon: TrendingUp, color: "purple" },
  orange: { icon: DollarSign, color: "orange" }
};

const Benefits = () => {
  return (
    <section id="beneficios" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Beneficios Comprobados
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Resultados <span className="text-green-600">medibles</span> desde el primer día
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Más de 1,000 empresas han transformado sus operaciones con SAIP. 
            Estos son los beneficios reales que puedes esperar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefitsData.map((benefit, index) => {
            const { icon: IconComponent, color } = iconMap[benefit.color];
            const colorClasses = {
              blue: "from-blue-500 to-blue-700",
              green: "from-green-500 to-green-700", 
              purple: "from-purple-500 to-purple-700",
              orange: "from-orange-500 to-orange-700"
            };

            return (
              <div 
                key={benefit.id}
                className="relative group"
                style={{animationDelay: `${index * 150}ms`}}
              >
                <div className="absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300"
                     style={{background: `linear-gradient(135deg, var(--${color}-500), var(--${color}-700))`}}>
                </div>
                
                <div className="relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100">
                  <div className="text-center">
                    <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${colorClasses[color]} text-white rounded-2xl mb-6 shadow-lg`}>
                      <IconComponent size={28} />
                    </div>
                    
                    <div className={`text-5xl font-bold bg-gradient-to-r ${colorClasses[color]} bg-clip-text text-transparent mb-2`}>
                      {benefit.percentage}
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {benefit.title}
                    </h3>
                    
                    <p className="text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              ROI promedio de <span className="text-green-600">300%</span> en el primer año
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              Nuestros clientes recuperan su inversión en promedio en solo 4 meses, 
              y continúan viendo mejoras significativas en eficiencia y rentabilidad durante años.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500" size={20} />
                <span className="text-gray-700">Implementación sin interrupciones operacionales</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500" size={20} />
                <span className="text-gray-700">Capacitación incluida para todo el equipo</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500" size={20} />
                <span className="text-gray-700">Soporte continuo y actualizaciones automáticas</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white p-8 rounded-2xl shadow-2xl">
              <div className="text-center mb-6">
                <div className="text-2xl font-bold text-gray-900 mb-2">Cálculo de ROI Personalizado</div>
                <p className="text-gray-600">Basado en tu volumen de operación actual</p>
              </div>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                  <span className="text-gray-600">Ahorro mensual estimado:</span>
                  <span className="font-bold text-green-600">$8,450</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                  <span className="text-gray-600">Inversión inicial:</span>
                  <span className="font-bold text-gray-900">$2,388</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg border border-green-200">
                  <span className="text-gray-600">Recuperación en:</span>
                  <span className="font-bold text-green-700">3.4 meses</span>
                </div>
              </div>
              
              <button className="w-full mt-6 bg-gradient-to-r from-green-600 to-green-700 text-white py-3 rounded-lg font-semibold hover:from-green-700 hover:to-green-800 transition-all">
                Calcular mi ROI Específico
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;